import $ from 'jquery';
import 'slick-carousel';


const catMenuOptions = {
   dots: false,
   infinite: true, 
   slidesToShow: 1,
   centerMode: true,
   variableWidth: true,
   mobileFirst: true,
   prevArrow: '',
   nextArrow: '<svg class="slick-arrow slick-arrow--next"><use xlink:href="#chevron-right-light"></use></svg>',
   responsive: [ 
      {
         breakpoint: 1200,
         settings: {
            centerMode: false,
         }
      }
   ]
}
$('#catSlider').slick(catMenuOptions);



const catOptions = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: '',
   nextArrow: '<div class="slick-arrow slick-arrow--next"><svg ><use xlink:href="#chevron-right-light"></use></svg></div>',
   responsive: [{
         breakpoint: 767,
         settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true
         }
      }
   ]
}


$('.jsProdSlider').each(function (index) {
   $(this).slick(catOptions);
});


const compOptions = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 3,
   slidesToScroll: 1,
   autoplay: true,
   prevArrow: '',
   nextArrow: '',
   responsive: [{
         breakpoint: 767,
         settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true
         }
      },
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: true
         }
      }
   ]
}

$('#compSlider').slick(compOptions);

const prCardOptions = {
   dots: false,
   infinite: true, 
   slidesToShow: 1,
   variableWidth: true,
   mobileFirst: true,
   prevArrow: '',
   nextArrow: '<div class="slick-arrow slick-arrow--next"><svg ><use xlink:href="#chevron-right-light"></use></svg></div>',
   responsive:[{
      breakpoint: 767,
      settings: {
         slidesToShow: 2,
         slidesToScroll: 1,
         infinite: true
      }
   },   
   {
      breakpoint: 980,
      settings: {
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: true
      }
   }
]
}

if(window.innerWidth < 1300) {
   $('#prCardGrid').slick(prCardOptions);
}



const catSlider = document.getElementById('catMenu');

if(catSlider) {
   const parentWdth = catSlider.parentElement.offsetWidth  
   if(catSlider.offsetWidth > parentWdth) {     
      if(window.innerWidth > 1199 &&  catSlider.dataset.width !== 'full') {
         catSlider.style.width = 'calc(100% - 100px)';
      }else{
         catSlider.style.width = '100%'
      }
      $('#catMenu').slick({ 
         dots: false,
         infinite: true,
         slidesToShow: 1,  
         slidesToScroll: 2,
         mobileFirst: true,
         prevArrow: '',
         nextArrow: '<div class="slick-arrow slick-arrow--next"><svg ><use xlink:href="#chevron-right-light"></use></svg></div>',
         variableWidth: true,
         swipe: false,
         responsive:[  
         {
            breakpoint: 980,
            settings: {            
               slidesToScroll: 4,             
            }
         }
      ]
      });
   }
  
}

const heroOptions = {
   dots: false,
   infinite: true, 
   slidesToShow: 1,
   prevArrow: '<svg class="slick-arrow slick-arrow--prev"><use xlink:href="#chevron-left-light"></use></svg>',
   nextArrow: '<svg class="slick-arrow slick-arrow--next"><use xlink:href="#chevron-right-light"></use></svg>',
}
$('#exempleSlider').slick(heroOptions);
